import axios from 'axios'

import * as chat from '.'
import * as base from './ChatClientOfficialBase'

import { login } from '@/api/douyin/douyin'

import ChatClientOfficialBase from './ChatClientOfficialBase'
import {setToken} from "@/utils/auth";

const GAME_HEARTBEAT_INTERVAL = 20 * 1000

export default class ChatClientDirectOpenLive extends ChatClientOfficialBase {
  constructor(roomOwnerAuthCode, skin) {
    super()
    this.CMD_CALLBACK_MAP = CMD_CALLBACK_MAP

    this.roomOwnerAuthCode = roomOwnerAuthCode
    this.skin = skin

    // 调用initRoom后初始化
    this.roomOwnerOpenId = null
    this.hostServerUrlList = []
    this.xfdHostServerUrlList = []
    this.authBody = null
    this.gameId = null

    this.gameHeartbeatTimerId = null
  }

  stop() {
    this.endGame()
    super.stop()
  }

  async initRoom() {
    return true
  }

  async wsConnect() {
    await super.wsConnect()
    if (this.isDestroying) {
      return
    }
    if (this.gameId && this.gameHeartbeatTimerId === null) {
      this.gameHeartbeatTimerId = window.setTimeout(this.onSendGameHeartbeat.bind(this), GAME_HEARTBEAT_INTERVAL)
    }
  }

  onWsClose() {
    if (this.gameHeartbeatTimerId) {
      window.clearTimeout(this.gameHeartbeatTimerId)
      this.gameHeartbeatTimerId = null
    }

    super.onWsClose()
  }

  async startGame() {
    let returnValue = false;
    try {

      await login(this.roomOwnerAuthCode).then(res => {
        setToken(res.data.access_token)
        let data = res.data
        let webSocketUrl = data.wssUrl
        this.hostServerUrlList.push(webSocketUrl)

        let protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
        let xfdWebSocketUrl = protocol + window.location.host + process.env.VUE_APP_BASE_API + '/live-chat/barrage/websocket'
        xfdWebSocketUrl = xfdWebSocketUrl + '?Authorization=Bearer ' + res.data.access_token + '&clientid=' + process.env.VUE_APP_CLIENT_ID
        this.xfdHostServerUrlList.push(xfdWebSocketUrl)
        returnValue = true
      }).catch(error => {
        throw Error(error)
      })

      /*let html = (await axios.get('/dy/' + this.roomOwnerAuthCode)).data
      const matchRes = html.match(
          /<script\snonce="\S+?"\s>self\.__pace_f\.push\(\[1,"[a-z]?:\[\\"\$\\",\\"\$L\d+\\",null,([\s\S]+?)\]\\n"\]\)<\/script>/
      );
      const REGLIST = [
        {
          reg: /\\{1,7}"/g,
          str: '"'
        },
        {
          reg: /"\{/g,
          str: '{'
        },
        {
          reg: /\}"/g,
          str: '}'
        },
        {
          reg: /"\[/g,
          str: '['
        },
        {
          reg: /\]"/g,
          str: ']'
        }
      ];
      if (!matchRes) throw new Error('房间信息获取失败');
      // 获取目标信息编码字符串，替换其中的转义字符
      let json = matchRes[1];
      for (const REG of REGLIST) {
        json = json.replace(REG.reg, REG.str);
      }
      // let dict = JSON.parse(decodeURIComponent(matchRes[1]));
      const dict = JSON.parse(json);
      let roomId = dict['state']['roomStore']['roomInfo']['roomId'];
      let roomTitle = dict['state']['roomStore']['roomInfo']['room']['title'];
      let roomUserCount = dict['state']['roomStore']['roomInfo']['room']['user_count_str'];
      let uniqueId = dict['state']['userStore']['odin']['user_unique_id'];
      let avatar = dict['state']['roomStore']['roomInfo']['anchor']['avatar_thumb']['url_list'][0];
      let sign = window.getSign(roomId, uniqueId)['X-Bogus'];
      let now = Date.now();
      let wsUrl = `wss://webcast3-ws-web-hl.douyin.com/webcast/im/push/v2/?app_name=douyin_web&version_code=180800&webcast_sdk_version=1.3.0&update_version_code=1.3.0&compress=gzip&internal_ext=internal_src:dim|wss_push_room_id:${roomId}|wss_push_did:${uniqueId}|fetch_time:${now}|seq:1|wss_info:0-${now}-0-0&cursor=t-${now}_r-1_d-1_u-1_h-1&host=https://live.douyin.com&aid=6383&live_id=1&did_rule=3&debug=false&maxCacheMessageNumber=20&endpoint=live_pc&support_wrds=1&im_path=/webcast/im/fetch/&user_unique_id=${uniqueId}&device_platform=web&cookie_enabled=true&screen_width=1920&screen_height=1080&browser_language=zh-CN&browser_platform=Win32&browser_name=Mozilla&browser_version=5.0%20(Windows%20NT%2010.0;%20Win64;%20x64)%20AppleWebKit/537.36%20(KHTML,%20like%20Gecko)%20Chrome/111.0.0.0%20Safari/537.36%20Edg/111.0.1661.62&browser_online=true&tz_name=Asia/Shanghai&identity=audience&room_id=${roomId}&heartbeatDuration=0&signature=${sign}`;
      this.hostServerUrlList.push(wsUrl)*/

    } catch (e) {
      // console.error('startGame failed:', e)
      if (e instanceof chat.ChatClientFatalError) {
        throw e
      }
      returnValue = false
    }
    return returnValue
  }

  async endGame() {
    if (!this.gameId) {
      return true
    }

    try {
      let res = (await axios.post('/api/open_live/end_game', {
        app_id: 0,
        game_id: this.gameId
      })).data
      if (res.code !== 0) {
        if (res.code === 7000 || res.code === 7003) {
          // 项目已经关闭了也算成功
          return true
        }
        throw Error(`code=${res.code}, message=${res.message}, request_id=${res.request_id}`)
      }
    } catch (e) {
      console.error('endGame failed:', e)
      return false
    }
    return true
  }

  onSendGameHeartbeat() {
    // 加上随机延迟，减少同时请求的概率
    let sleepTime = GAME_HEARTBEAT_INTERVAL - (2 * 1000) + (Math.random() * 3 * 1000)
    this.gameHeartbeatTimerId = window.setTimeout(this.onSendGameHeartbeat.bind(this), sleepTime)
    this.sendGameHeartbeat()
  }


  async sendGameHeartbeat() {
    if (!this.gameId) {
      return false
    }

    // 保存一下，防止await之后gameId改变
    let gameId = this.gameId
    try {
      let res = (await axios.post('/api/open_live/game_heartbeat', {
        game_id: this.gameId
      })).data
      if (res.code !== 0) {
        console.error(`sendGameHeartbeat failed: code=${res.code}, message=${res.message}, request_id=${res.request_id}`)

        if (res.code === 7003 && this.gameId === gameId) {
          // 项目异常关闭，可能是心跳超时，需要重新开启项目
          this.needInitRoom = true
          this.discardWebsocket()
        }

        return false
      }
    } catch (e) {
      console.error('sendGameHeartbeat failed:', e)
      return false
    }
    return true
  }

  async onBeforeWsConnect() {
    // 重连次数太多则重新initRoom，保险
    let reinitPeriod = Math.max(3, (this.hostServerUrlList || []).length)
    if (this.retryCount > 0 && this.retryCount % reinitPeriod === 0) {
      this.needInitRoom = true
      await this.endGame()
    }
    return super.onBeforeWsConnect()
  }

  getWsUrl() {
    return this.hostServerUrlList[this.hostServerUrlList.length - 1]
  }

  getXfdWsUrl() {
    return this.xfdHostServerUrlList[this.xfdHostServerUrlList.length - 1]
  }

  getSkin() {
    return this.skin
  }

  sendAuth() {
    this.websocket.send(this.makePacket(this.authBody, base.OP_AUTH))
  }

  delayReconnect() {
    if (document.visibilityState !== 'visible') {
      // 不知道什么时候才能重连，先endGame吧
      this.needInitRoom = true
      this.endGame()
    }

    super.delayReconnect()
  }


  async dmCallback(command) {
    if (!this.onAddText) {
      return
    }
    let data = command.data

    let authorType
    if (data.open_id === this.roomOwnerOpenId) {
      authorType = 3
    } else if (data.guard_level !== 0) {
      authorType = 1
    } else {
      authorType = 0
    }

    let emoticon = null
    if (data.dm_type === 1) {
      emoticon = data.emoji_img_url
    }

    data = {
      avatarUrl: chat.processAvatarUrl(data.uface),
      timestamp: data.timestamp,
      authorName: data.uname,
      authorType: authorType,
      content: data.msg,
      privilegeType: data.guard_level,
      isGiftDanmaku: chat.isGiftDanmakuByContent(data.msg),
      authorLevel: 1,
      isNewbie: false,
      isMobileVerified: true,
      medalName: data.fans_medal_name,
      medalLevel: data.fans_medal_level,
      isFanGroup: data.fans_medal_wearing_status ? true : false,
      id: data.msg_id,
      translation: '',
      emoticon: emoticon,
    }
    this.onAddText(data)
  }

  sendGiftCallback(command) {
    if (!this.onAddGift) {
      return
    }

    let data = command.data
    // console.log("ChatClientDirectOpenLive.js.sendGiftCallback().data0=" + JSON.stringify(data))
    if (!data.paid) { // 丢人
      data.price = 0
    }
    // console.log("ChatClientDirectOpenLive.js.sendGiftCallback().data1=" + JSON.stringify(data))
    data = {
      id: data.msg_id,
      avatarUrl: chat.processAvatarUrl(data.uface),
      timestamp: data.timestamp,
      authorName: data.uname,
      privilegeType: data.guard_level,
      paid: data.paid,
      totalCoin: data.price * data.gift_num,
      totalPrice: (data.price * data.gift_num / 1000).toFixed(2),
      giftName: data.gift_name,
      num: data.gift_num,
      medalName: data.fans_medal_name,
      medalLevel: data.fans_medal_level,
      isFanGroup: data.fans_medal_wearing_status ? true : false
    }
    // console.log("ChatClientDirectOpenLive.js.sendGiftCallback().data2=" + JSON.stringify(data))
    this.onAddGift(data)
  }

  async guardCallback(command) {
    if (!this.onAddMember) {
      return
    }

    let data = command.data
    data = {
      id: data.msg_id,
      giftName: data.gift_name,
      avatarUrl: chat.processAvatarUrl(data.user_info.uface),
      timestamp: data.timestamp,
      authorName: data.user_info.uname,
      privilegeType: data.guard_level,
      guardNum: data.guard_num,
      guardUnit: data.guard_unit,
      medalName: data.fans_medal_name,
      medalLevel: data.fans_medal_level,
      isFanGroup: data.fans_medal_wearing_status ? true : false,
      totalPrice: (data.price * data.guard_num / 1000).toFixed(2)
    }
    this.onAddMember(data)
  }

  superChatCallback(command) {
    if (!this.onAddSuperChat) {
      return
    }

    let data = command.data
    data = {
      id: data.message_id.toString(),
      avatarUrl: chat.processAvatarUrl(data.uface),
      timestamp: data.start_time,
      authorName: data.uname,
      price: data.rmb,
      content: data.message,
      translation: '',
      medalName: data.fans_medal_name,
      medalLevel: data.fans_medal_level,
      isFanGroup: data.fans_medal_wearing_status ? true : false
    }
    this.onAddSuperChat(data)
  }

  superChatDelCallback(command) {
    if (!this.onDelSuperChat) {
      return
    }

    let ids = []
    for (let id of command.data.message_ids) {
      ids.push(id.toString())
    }
    this.onDelSuperChat({ ids })
  }
}

const CMD_CALLBACK_MAP = {
  LIVE_OPEN_PLATFORM_DM: ChatClientDirectOpenLive.prototype.dmCallback,
  LIVE_OPEN_PLATFORM_SEND_GIFT: ChatClientDirectOpenLive.prototype.sendGiftCallback,
  LIVE_OPEN_PLATFORM_GUARD: ChatClientDirectOpenLive.prototype.guardCallback,
  LIVE_OPEN_PLATFORM_SUPER_CHAT: ChatClientDirectOpenLive.prototype.superChatCallback,
  LIVE_OPEN_PLATFORM_SUPER_CHAT_DEL: ChatClientDirectOpenLive.prototype.superChatDelCallback
}
